import { render, staticRenderFns } from "./SequenceOfNumbersPreview.vue?vue&type=template&id=10ff50db&lang=pug&"
import script from "./SequenceOfNumbersPreview.vue?vue&type=script&lang=js&"
export * from "./SequenceOfNumbersPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports